module.exports = __webpack_public_path__ + "media/images/referral4-cff0a058.png";